import { render, staticRenderFns } from "./EditarInformacoesClube.vue?vue&type=template&id=131e1711"
import script from "./EditarInformacoesClube.vue?vue&type=script&lang=ts"
export * from "./EditarInformacoesClube.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports